import { createAction, props } from '@ngrx/store';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';
import { DeepPartial } from '../../utils/types';
import { SeSideNavComponentState } from './se-side-nav.state';

export enum SeSideNavComponentActions {
    SET_ACTIVE_COMPONENTS = '[SeSideNavComponent] SetActiveComponents'
}

export const seSideNavComponentSetActiveComponents =
    createAction(SeSideNavComponentActions.SET_ACTIVE_COMPONENTS, props<{
        activationList: SeSideComponentType[],
        customProps?: DeepPartial<SeSideNavComponentState>}>());

